const defaultLocale = 'en-US';
const defaultOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
} as Intl.DateTimeFormatOptions;

const FormattedRecordTimestamp = ({
                                      record,
                                      propertyName,
                                      selectedLocale,
                                      formatOptions
                                  }: {
    record: { [key: string]: any },
    propertyName: string,
    selectedLocale?: string,
    formatOptions?: Intl.DateTimeFormatOptions
}) => {

    let formatted = null;

    if (record && typeof propertyName !== 'undefined') {

        let locale = defaultLocale;
        if (typeof selectedLocale !== 'undefined') {
            locale = selectedLocale;
        }

        let options = defaultOptions;
        if (typeof formatOptions !== 'undefined') {
            options = Object.assign({}, defaultOptions, formatOptions);
        }

        formatted = new Date(record[propertyName]).toLocaleDateString(locale, options);
    }


    return (<span>{formatted}</span>);

};

export default FormattedRecordTimestamp;
